import { createQueryData } from '../helpers/createQueryData';

const {
  useQuery: useIntervalTypesQuery,
  createKey: createIntervalTypesQueryKey,
  fn: fetchIntervalTypes,
} = createQueryData({
  endPoint: 'Acceptance/intervals_time_types',
});

export {
  useIntervalTypesQuery,
  createIntervalTypesQueryKey,
  fetchIntervalTypes,
};
